import React from 'react';
import Header from "./Header";

const Layout = ({...props}) => {
    return (
        <div className="">
            <div className="sticky top-0 z-10">
                <Header/>
            </div>

            <div className="ml-8 mt-4 mb-10">
                {props.children}
            </div>
        </div>
    );
}

export default Layout;
